// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function ChartLineDownBoldIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M29.5 26a1.5 1.5 0 0 1-1.5 1.5H4A1.5 1.5 0 0 1 2.5 26V6a1.5 1.5 0 0 1 3 0v1.375l6.5 6.5 2.939-2.94a1.5 1.5 0 0 1 2.125 0l6.436 6.44V16a1.5 1.5 0 1 1 3 0v5c0 .05-.003.1-.008.15 0 .02-.006.041-.008.061l-.013.084c-.005.027-.011.047-.017.07l-.019.073-.024.067c-.009.024-.016.047-.026.07l-.029.063c-.01.02-.021.047-.034.07-.012.025-.022.038-.033.057-.012.019-.027.047-.042.07-.014.023-.03.04-.044.059l-.043.059a1.632 1.632 0 0 1-.089.097l-.01.012-.012.01c-.032.032-.064.06-.098.09l-.057.042-.06.045c-.02.014-.046.027-.069.041-.023.014-.038.024-.058.034l-.07.034c-.023.01-.04.02-.063.028l-.068.027-.071.023a.648.648 0 0 1-.069.018l-.072.018-.08.012-.066.01A1.424 1.424 0 0 1 25 22.5h-5a1.5 1.5 0 1 1 0-3h1.375L16 14.125l-2.939 2.94a1.5 1.5 0 0 1-2.125 0L5.5 11.625V24.5H28a1.5 1.5 0 0 1 1.5 1.5Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
